<script lang="ts">
  import { delay } from '~/animations/utils.svelte';
  import Board from '../board/Board.svelte';
  import ShuffleIcon from '~icons/mdi/shuffle';
  import type { Coord } from '../types';
  import { onMount, tick } from 'svelte';
  import GameContext from '~/store/GameContext.svelte';
  import { shuffle, shuffleBoard } from '~/algorithms/shuffle';
  import { flipAnimation } from '~/animations/flip.svelte';
  import ActionButton from '~/components/ActionButton.svelte';
  import { Tutorial } from '~/store/daily.svelte';
  import { animationSpeed } from '~/animations/utils.svelte';
  import { lettersToBoard } from '~/board/utils';
  import DimensionsContext from '~/utils/DimensionsContext.svelte';

  type Props = {
    play: boolean;
  };
  const props: Props = $props();
  const getBoard = () =>
    lettersToBoard([
      ['A', 'D', 'G'],
      ['B', 'E', 'H'],
      ['C', 'F', 'I'],
    ]);

  const game = new Tutorial(getBoard());

  let clicked = $state(false);

  const runAnimation = async () => {
    await delay(1000);
    // for stagger
    game.lost = false;
    // board = game.board;

    const coords = Array.from({ length: game.board.length }).flatMap((_, i) =>
      Array.from({ length: game.board[0].length }).map((_, j): Coord => [i, j]),
    );

    const shuffled = shuffle([...coords]);
    clicked = true;
    await delay(250);
    game.board = shuffleBoard(game.board, coords, shuffled);

    // pause for animation
    await flipAnimation.settled();
    await delay(2000);
    clicked = false;
    game.board = getBoard().map((r, i) =>
      r.map((t, j) => ({
        ...t,
        flipped: true,
        id: game.board[i][j].id,
      })),
    );
    game.lost = true;
    await delay(animationSpeed.ms * 2);
    game.board.forEach((r) =>
      r.forEach((t) => {
        delete t.flipped;
      }),
    );
  };

  let mounted = false;
  onMount(() => {
    mounted = true;
    void startAnimation();
    return () => {
      mounted = false;
    };
  });

  let isPlaying = false;
  $effect(() => {
    if (props.play && !isPlaying) {
      startAnimation();
    }
  });

  const startAnimation = async () => {
    isPlaying = true;
    while (mounted && props.play) {
      await runAnimation();
      await tick();
    }
    isPlaying = false;
  };

  let width = 180;
  let height = 180;
</script>

<div class="container">
  <div class="shuffle-button" class:clicked>
    <ActionButton>
      1
      <ShuffleIcon size="1.5em" />
    </ActionButton>
  </div>
  <div class="board-container">
    <GameContext {game}>
      <DimensionsContext {...{ width, height }}>
        <Board disabled />
      </DimensionsContext>
    </GameContext>
  </div>
</div>

<style lang="scss">
  @use '~/theme/theme';

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    :global(*) {
      pointer-events: none;
    }
  }

  .shuffle-button {
    &.clicked :global(.action) {
      @include theme.pulse-animation(theme.$star-bonus);
    }
  }
</style>
